import { render } from "./SearchTermsDetail.vue?vue&type=template&id=11ead1c3"
import script from "./SearchTermsDetail.vue?vue&type=script&lang=js"
export * from "./SearchTermsDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__